"use client"

import { TbHome, TbTruck, TbCoffee, TbBurger, TbBeer, TbToolsKitchen2, TbGlassFull } from "react-icons/tb"
import { PROFILES } from "./data"

const CONCEPT_OPTIONS = [
   { key: "food-truck", icon: TbTruck, range: "$50K-$200K" },
   { key: "coffee-shop", icon: TbCoffee, range: "$80K-$300K" },
   { key: "fast-casual", icon: TbBurger, range: "$150K-$450K" },
   { key: "bar-brewery", icon: TbBeer, range: "$200K-$600K" },
   { key: "full-service", icon: TbToolsKitchen2, range: "$350K-$750K" },
   { key: "fine-dining", icon: TbGlassFull, range: "$500K-$1M+" },
] as const

export type ConceptSelectionProps = {
   activeConcept: string
   onConceptChange: (conceptKey: string) => void
}

export default function ConceptSelection({ activeConcept, onConceptChange }: ConceptSelectionProps) {
   return (
      <div className="mb-8 rounded-2xl border border-slate-200 bg-white p-5 sm:p-9 shadow-sm text-center">
         <div className="mb-7 flex items-center justify-center gap-3 text-custom-2xl-bold text-center">
            <TbHome className="h-6 w-6 text-custom-primary shrink-0" />
            <span>What type of restaurant?</span>
         </div>
         <div className="grid grid-cols-1 min-[440px]:grid-cols-2 sm:grid-cols-3 gap-4">
            {CONCEPT_OPTIONS.map(({ key, icon: IconComponent, range }) => {
               const isActive = activeConcept === key
               return (
                  <button
                     key={key}
                     type="button"
                     onClick={() => onConceptChange(key)}
                     className={`flex flex-col items-center justify-center gap-1.5 rounded-xl border p-6 text-center transition-all duration-200 ${
                        isActive
                           ? "border-[#f15a29] bg-[#FFF7ED] shadow-[0_0_0_1px_#f15a29]"
                           : "border-slate-200 bg-white hover:border-[#f15a29] hover:bg-[#FFF7ED]"
                     }`}
                  >
                     <IconComponent className="mb-1 h-7 w-7 text-custom-primary" />
                     <span className="text-custom-base-medium">{PROFILES[key].label}</span>
                     <span className="text-custom-xs-semibold">{range}</span>
                  </button>
               )
            })}
         </div>
      </div>
   )
}